import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './TermsGate.css';

/**
 * 📜 Экран согласия с публичной офертой при первом входе.
 * Показывается поверх всего, пока игрок не поставит галку и не нажмёт
 * «Принимаю». Статус хранится в БД (users.terms_accepted_at) и общий
 * с лобби слотов — второй раз спрашивать не будем.
 */
const OFFER_URL_RU = 'https://gitbook.safepermoon.com/#oferta';
const OFFER_URL_EN = 'https://gitbook.safepermoon.com/en.html#oferta';

interface TermsGateProps {
  onAccepted: () => void;
}

const TermsGate: React.FC<TermsGateProps> = ({ onAccepted }) => {
  const { t, i18n } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const offerUrl = i18n.language === 'ru' ? OFFER_URL_RU : OFFER_URL_EN;

  const openOffer = () => {
    const tg = (window as any).Telegram?.WebApp;
    if (tg?.openLink) tg.openLink(offerUrl);
    else window.open(offerUrl, '_blank');
  };

  const handleAccept = async () => {
    if (!checked || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await api.post('/user/terms/accept');
      onAccepted();
    } catch (e) {
      setError(t('terms.error'));
      setSubmitting(false);
    }
  };

  return (
    <div className="terms-gate">
      <div className="terms-container">
        <div className="terms-icon">📜</div>

        <h1 className="terms-title">{t('terms.title')}</h1>
        <p className="terms-subtitle">{t('terms.subtitle')}</p>

        <div className="terms-points">
          <p>{t('terms.point1')}</p>
          <p>{t('terms.point2')}</p>
          <p>{t('terms.point3')}</p>
        </div>

        <button className="terms-link-button" onClick={openOffer}>
          {t('terms.read')}
        </button>

        <label className="terms-checkbox">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span>{t('terms.checkbox')}</span>
        </label>

        {error && <p className="terms-error">{error}</p>}

        <button
          className="terms-accept-button"
          onClick={handleAccept}
          disabled={!checked || submitting}
        >
          {submitting ? t('terms.saving') : t('terms.accept')}
        </button>

        <div className="terms-footer">
          <p>{t('terms.hint')}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsGate;
